import type { CompareDateTimePickerAlias, IDateTimePickerProps } from '~/presentation/ui';

import {
  useDateTimePickerContext,
  DATE_TIME_COMPARISON_FILTERS,
  COMPARE_DATE_TIME_FILTERS_MAP,
  getMonthAndYearByDateFilter,
} from '~/presentation/ui';
import { dayjsTz } from '~/utils/dayjs';
import { useState } from 'react';

interface ICompareDateTimePickerProps extends IDateTimePickerProps {}

export const useCompareDateTimePicker = ({ ranges, onApply }: ICompareDateTimePickerProps) => {
  const allRanges = ranges || DATE_TIME_COMPARISON_FILTERS;

  const { compareDateTimePicked, setCompareDateTimePicked } = useDateTimePickerContext();
  const { dateTimePicked: mainDateRange } = useDateTimePickerContext();

  const [dateRange, setDateRange] = useState(compareDateTimePicked);
  const [{ month, year }, setDate] = useState({
    month: dayjsTz(compareDateTimePicked.since).month(),
    year: dayjsTz(compareDateTimePicked.since).year(),
  });

  const onMonthChange = (month: number, year: number) => {
    setDate({ month, year });
  };

  const onCalendarChange = ({ start, end, alias }: { start: Date; end: Date; alias?: string }) => {
    const newDateRange = allRanges.find((range) => {
      return range.alias === alias;
    });

    // If the alias is not found, set the custom date range
    if (!newDateRange) {
      setDateRange({
        alias: 'custom',
        title: 'Custom',
        since: start.getTime(),
        until: end.getTime(),
      });
      return;
    }

    setDateRange({
      ...newDateRange,
      ...COMPARE_DATE_TIME_FILTERS_MAP[alias as CompareDateTimePickerAlias]({
        since: mainDateRange.since,
        until: mainDateRange.until,
      }),
    });
  };

  const apply = () => {
    setCompareDateTimePicked(dateRange);
    onApply?.(dateRange);
  };

  const cancel = () => {
    setDateRange(compareDateTimePicked);
  };
  const onChange = ({ end }: { start: Date; end: Date }) => {
    setDate(getMonthAndYearByDateFilter(month, year, end));
  };

  return {
    month,
    year,
    setDate,
    dateRange,
    apply,
    cancel,
    compareDateTimePicked,
    onChange,
    onMonthChange,
    onCalendarChange,
  };
};
